'use client';

import { useState, useEffect } from 'react';
import { ContactForwarderModal } from '@/components/contact/contact-forwarder-modal';
import { normalizeWebsiteForHref } from '@/lib/safe-external-url';
import posthog from 'posthog-js';

interface ExperimentalForwarderClientProps {
  forwarderId: string;
  forwarderName: string;
  website: string | null;
}

export function ForwarderProfileClient({
  forwarderId,
  forwarderName,
  website,
}: ExperimentalForwarderClientProps) {
  const [contactModalOpen, setContactModalOpen] = useState(false);
  const safeWebsite = normalizeWebsiteForHref(website);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    posthog.capture('forwarder_profile_viewed', {
      forwarder_name: forwarderName,
      forwarder_id: forwarderId,
    });
  }, []);

  return (
    <>
      <div className="sidebar-section contact-section">
        <h3 className="sidebar-title">Get in Touch</h3>
        <button
          className="contact-btn primary"
          onClick={() => {
            posthog.capture('forwarder_contact_clicked', {
              forwarder_name: forwarderName,
              forwarder_id: forwarderId,
              contact_type: 'quote_request',
            });
            setContactModalOpen(true);
          }}
        >
          Request Quote
        </button>
        {safeWebsite && (
          <a
            href={safeWebsite}
            target="_blank"
            rel="noopener noreferrer"
            className="contact-btn secondary"
            onClick={() => posthog.capture('forwarder_contact_clicked', {
              forwarder_name: forwarderName,
              forwarder_id: forwarderId,
              contact_type: 'website',
            })}
          >
            Visit Website ↗
          </a>
        )}
        <p className="contact-note">
          Your message will be sent securely through Shipzy
        </p>
      </div>

      <ContactForwarderModal
        open={contactModalOpen}
        onClose={() => setContactModalOpen(false)}
        forwarderId={forwarderId}
        forwarderName={forwarderName}
        sourcePage="forwarder_profile"
      />
    </>
  );
}
